import { useEffect, useState } from "react";
import {
  MiButton,
  MiChip,
  MiDetailPageHeader,
  MiTab,
} from "@miplatform/components";
import { BUTTON_VARIANTS, ICONS_WEB, PERMISSIONS } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { usePermissions } from "@mibuildweb/hooks";
import { Box } from "@mui/material";
import { PLAN_SERIES_TABS, PLAN_SERIES_TAB_VALUES } from "../../constants";
import { PlanSeriesCommunitiesPlansTab } from "./PlanSeriesCommunitiesPlansTab/PlanSeriesCommunitiesPlansTab";
import { usePlanSeriesCommunitiesDetailViewModel } from "./usePlanSeriesCommunitiesDetailViewModel";

export function PlanSeriesCommunitiesDetail() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { hasPermission } = usePermissions();

  const hasImportPermission = hasPermission(PERMISSIONS.PLAN.IMPORT);
  const {
    params: { accountId, tab, seriesOrCommunityId, seriesOrCommunityTab },
    navigate,
  } = useRouter();
  const {
    isLoading,
    stateManager,
    seriesDetail,
    accountDetail,
    getSeriesDetail,
    getAccountDetail,
    community,
    getCommunityDetails,
  } = usePlanSeriesCommunitiesDetailViewModel();

  useEffect(() => {
    getAccountDetail(accountId);
  }, []);

  useEffect(() => {
    if (tab === "series" && seriesOrCommunityId) {
      getSeriesDetail(seriesOrCommunityId);
    }
    if (tab === "communities" && seriesOrCommunityId) {
      getCommunityDetails(seriesOrCommunityId);
    }
  }, []);

  const renderActions = () => {
    return (
      <Box display="flex" gap={2}>
        {hasImportPermission && (
          <MiButton
            title="Import Bid"
            variant={BUTTON_VARIANTS.OUTLINED}
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            onClick={() => setOpenDrawer(true)}
          />
        )}
        {tab === "series" && (
          <MiButton
            title="Create New Bid"
            variant={BUTTON_VARIANTS.CONTAINED}
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            onClick={() =>
              navigate(
                `/estimating/bids/${accountId}/${tab}/${seriesOrCommunityId}/add-bid`,
                { state: { seriesDetail, accountDetail } }
              )
            }
          />
        )}
      </Box>
    );
  };

  const handleTabChange = (seriesOrCommunityTab) => {
    navigate(
      `/estimating/bids/${accountId}/${tab}/${seriesOrCommunityId}/${seriesOrCommunityTab}`
    );
  };

  return (
    <>
      <Box>
        <MiDetailPageHeader
          title={
            <Box display="flex" alignItems="center" gap={2}>
              {accountDetail.status && (
                <MiChip
                  color={
                    accountDetail.status === "Active" ? "success" : "error"
                  }
                  label={accountDetail.status}
                  sx={{ borderRadius: 1 }}
                />
              )}
              Bids: {accountDetail.name}
            </Box>
          }
          subTitles={[
            accountDetail.accountType,
            seriesDetail.name || community.name,
          ]}
          customOnBack={() => navigate(`/estimating/bids/${accountId}/${tab}`)}
          loading={isLoading}
          actionComponent={renderActions()}
        />
        <MiTab
          tabs={PLAN_SERIES_TABS}
          currentTab={seriesOrCommunityTab}
          onTabChange={handleTabChange}
          borderBottom
        />
      </Box>
      {[
        PLAN_SERIES_TAB_VALUES.ALL_PLANS,
        PLAN_SERIES_TAB_VALUES.ACTIVE_PLANS,
        PLAN_SERIES_TAB_VALUES.INACTIVE_PLANS,
      ].includes(seriesOrCommunityTab) && (
        <PlanSeriesCommunitiesPlansTab
          stateManager={stateManager}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          accountDetail={accountDetail}
        />
      )}
    </>
  );
}
